import { constants } from "../constants/redux-constants";

const initialState = {
  encounter: {},
  visitList: {},
  toggleSelect: true,
  encounterResource: {},
  selectedArchivedEncounter:  {},
  observations: [],
  encounterNote: "",
  isFirstVisitSelected: false,
  previousEncounterObservations: [],
  quickActionToggle: false,
  consolidatedNote: "",
};

const EncounterReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.ENCOUNTER?.ENCOUNTER_OBJECT:
      return {
        ...state,
        encounter: action?.payload,
      };
    case constants?.ENCOUNTER?.VISIT_OBJECT:
      return {
        ...state,
        visitList: action?.payload,
      };
    case constants?.ENCOUNTER?.ADD_VISIT:
      return {
        ...state,
        visitList: [action?.payload, ...state?.visitList],
      };
    case constants?.ENCOUNTER?.TOGGLE_SELECT:
      return {
        ...state,
        toggleSelect: action?.payload,
      };
    case constants?.ENCOUNTER?.QUICK_ACTION_TOGGLE:
      return {
        ...state,
        quickActionToggle: action?.payload,
      };
    case constants?.ENCOUNTER?.ENCOUNTER_RESOURCE:
      return {
        ...state,
        encounterResource: action?.payload,
      };
    case constants?.ENCOUNTER?.ARCHIVED_ENCOUNTER_RESOURCE:
      return {
        ...state,
        selectedArchivedEncounter: action?.payload,
      };
    case constants?.ENCOUNTER?.ENCOUNTER_NOTE:
      return {
        ...state,
        encounterNote: action?.payload,
      };
    case constants?.ENCOUNTER?.SET_OBSERVATIONS:
      return {
        ...state,
        observations: action?.payload,
      };
    case constants?.ENCOUNTER?.CONSOLIDATED_NOTE:
      return {
        ...state,
        consolidatedNote: action?.payload,
      };
    case constants?.ENCOUNTER?.FIRST_VISIT_SELECTED:
      return {
        ...state,
        isFirstVisitSelected: action?.payload
      }
    case constants?.ENCOUNTER?.PREVIOUS_ENCOUNTER_OBSERVATIONS:
      return {
        ...state,
        previousEncounterObservations: action?.payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default EncounterReducer;
